import router from '../../route/routes.js';
const state = {
  webinar_id: null,
}

const actions = {
  setWebinarId({commit}, payload) {
    commit('SET_WEBINAR_ID', payload)
  },
}

const mutations = {
  'SET_WEBINAR_ID'(state, payload) {
    if (Object.keys(payload).length) {
      if (payload.from) {
        window.open('https://www.loket.com/event/modal-minim-untung-maksimal-passive-income-dari-bisnis_f93t?utm_source=metaads&utm_medium=conversion&utm_campaign=webinar24mei', '_self')
      }
      else {
        router.replace({
          name: "Pendaftaran webinar berhasil",
          query: { q: payload.payload }
        });
      }
    }
    state.webinar_id = payload.payload
  },
}

const getters = {
  WEBINAR_ID: state => {
    return state.webinar_id
  },
}

export default {
  state,
  actions,
  mutations,
  getters
}
